import axios from 'axios';

export default {
  validate (params) {
    return new Promise((resolve, reject) => {
      let urlRecaptcha = '';
      if (process.env.PORT_API === 80) { // dsv || dev
        urlRecaptcha = 'https://' + process.env.HOST_API + '/api/recaptcha/check/';
      } else { // local
        urlRecaptcha = 'http://' + process.env.HOST_API + ':' + process.env.PORT_API + '/api/recaptcha/check/';
      }
      axios.post(urlRecaptcha, params)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message);
          } else {
            console.log(response.data.success);
            resolve(response.data.success);
          }
        })
        .catch(error => {
          console.log('Error');
          if (error.response.data.hasOwnProperty('hasErrors')) {
            console.log(error.message.data.message);
            reject(error.response.data.message);
          } else {
            console.log(error.message);
            reject(error.message);
          }
        });
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/utils/recaptchaValidate.js